<template>
    <div :class="$style.wrapper">
        <h1>个人信息</h1>
        <div v-if="userInfo" :class="$style.form">
            <el-form ref="form" :rules="rules" :model="userInfo" label-width="100px">
                <el-form-item label="姓名：">
                    <el-input v-model="userInfo.user_name" disabled></el-input>
                </el-form-item>
                <el-form-item label="手机号：">
                    <el-input v-model="userInfo.mobile" disabled></el-input>
                </el-form-item>
                <div v-if="userInfo.user_type==='1'" >
                    <el-form-item label="职位：">
                        <el-input value="经销商" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="钱包余额：">
                        <el-input v-model="userInfo.user_money_noformat||0" disabled></el-input>
                    </el-form-item>
                </div>
                <div v-else>
                    <el-form-item label="职位：">
                        <el-input value="员工" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="员工号：">
                        <el-input v-model="userInfo.staff_sn" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="佣金：">
                        <el-input v-model="userInfo.commission+'%'" disabled></el-input>
                    </el-form-item>
                </div>
                <!--<el-form-item>-->
                    <!--<el-button :class="$style.submitBtn">-->
                        <!--提交保存-->
                    <!--</el-button>-->
                <!--</el-form-item>-->
            </el-form>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex';
    export default {
        data () {
            return {
                formData: {
                    name: '萧雅彤',
                    workerNo: '1003',
                    phoneNo: '18565647765',
                    department: '销售1组',
                    position: '组长',
                    brokerage: '17.45%',
                }
            };
        },
        computed: {
            ...mapState(['userInfo'])
           
        },
    };
</script>

<style lang="less" module>
    @import "common";

    .wrapper {
        & > h1 {
            font-size: 20px;
            color: #636975;
        }
        .form {
            width: 400Px;
            input {
                border-radius: 0;
            }
            .submitBtn {
                .submitBtn;
            }
        }

    }
</style>



// WEBPACK FOOTER //
// src/components/UserInfo/User.vue